import { render } from "./Prep.vue?vue&type=template&id=6e6c152d&scoped=true&ts=true"
import script from "./Prep.vue?vue&type=script&lang=ts"
export * from "./Prep.vue?vue&type=script&lang=ts"

import "./Prep.vue?vue&type=style&index=0&id=6e6c152d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6c152d"]])

export default __exports__